import type { BrowserKey } from '../utils/constants';
import type { ChangeEvent } from 'react';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Hint, Icon } from '@vestigas/ui';
import { InputLabel } from '~/ui/molecules/TanstackForm';

import { detectBrowser } from '../utils';

import { FileRow } from './FileRow';
import { HarInstructions } from './HarInstructions';

type P = {
  readonly harFile: File | undefined;
  readonly isBusy: boolean;
  readonly isInstructionsOpen: boolean;
  readonly onAttachFile: (
    setter: (file: File) => void,
  ) => (event: ChangeEvent<HTMLInputElement>) => void;
  readonly setHarFile: (file: File | undefined) => void;
  readonly toggleInstructions: () => void;
};

export function HarFileSection({
  harFile,
  isBusy,
  isInstructionsOpen,
  onAttachFile,
  setHarFile,
  toggleInstructions,
}: P) {
  const { t } = useTranslation('bugReport');

  const [expandedBrowser, setExpandedBrowser] = useState<BrowserKey | null>(
    detectBrowser,
  );

  return (
    <div className="flex flex-col gap-1">
      <InputLabel>
        <span className="inline-flex items-center gap-1">
          <Icon className="shrink-0" metaphor="networkCheck" size="sm" />
          {t(($) => $.dialog.har.label)}
        </span>
      </InputLabel>
      {harFile ? (
        <FileRow
          disabled={isBusy}
          file={harFile}
          removeLabel={t(($) => $.dialog.har.removeText)}
          onClear={() => setHarFile(undefined)}
        />
      ) : (
        <>
          <Hint className="-mt-1.5 block">{t(($) => $.dialog.har.hint)}</Hint>
          <Button
            buttonStyle="secondary"
            component="label"
            disabled={isBusy}
            size="small"
          >
            {t(($) => $.dialog.har.attachText)}
            <input
              accept=".har"
              hidden
              type="file"
              onChange={onAttachFile(setHarFile)}
            />
          </Button>
          <Button
            buttonStyle="link"
            size="small"
            className="justify-start"
            onMouseDown={toggleInstructions}
            text={
              isInstructionsOpen
                ? t(($) => $.dialog.har.closeHowToExport)
                : t(($) => $.dialog.har.howToExport)
            }
          />
        </>
      )}

      <HarInstructions
        expandedBrowser={expandedBrowser}
        isOpen={isInstructionsOpen}
        toggleBrowser={setExpandedBrowser}
      />
    </div>
  );
}
